import React, { Component } from 'react';
import "../App.css";

class Canvas extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if(document.getElementById("canvas_container") != null){
            document.getElementById("canvas_container").innerHTML = "";
        }

        if(document.getElementById("canvas_container") != null ) {
            window.init("canvas_container");
        }else{
        }
    }

    render() {
        if(document.getElementById("canvas_container") != null){
            document.getElementById("canvas_container").innerHTML = "";
        }
        
        if(document.getElementById("canvas_container") != null ) {
            window.init("canvas_container");
        }else{
        }

        return (
            <div>
                <div className='MyContainer'>

                    <div id="canvas_container">

                    </div>
                </div>

            </div>
        );
    }
}

export default(Canvas)